export default __webpack_public_path__ + "static/media/cognizant.d4ff8569.jpg";